import React from 'react'
import {useHistory} from 'react-router-dom'
import {motion} from "framer-motion";

const contVariant={
  hidden:{
    opacity:0
  },
  visible:{
    opacity:1,
    transition:{
      duration:0.5
    }
  }
}
export default function Template2() {
	const history=useHistory()
	const data=JSON.parse(localStorage.getItem("resumeData"))
	function download(){
		var body=document.body.innerHTML
		var data=document.getElementById("resume").innerHTML
		document.body.innerHTML=data
		document.body.style.background="white"
		window.print()
		document.body.style.background="linear-gradient(to right,rgb(10, 81, 89) 20%,rgb(13, 153, 136),rgb(10, 81, 89) 80%)"
		document.body.innerHTML=body
		window.location.reload()
	}
	if(!data) return <motion.div className="container" exit={{opacity:0}} variants={contVariant} initial="hidden" animate="visible"><h2>Something went wrong, please resave the data</h2></motion.div>
	return (
		<>
		<motion.div className="container" style={{flexDirection:"column"}} exit={{opacity:0}}
			variants={contVariant}
        	initial="hidden"
        	animate="visible"
		>
			<div>
				<button className="save-btn mx-2" onClick={()=>history.push("/choose-resume-template")}>Back</button>
				<button className="save-btn" onClick={download}>Download</button>
			</div>
			<div className="resume" id="resume">
				<div className="mt-1 d-flex flex-column align-items-center" style={{background:"rgba(2,84,77,1)",textAlign:"center",color:"white",padding:"20px",fontWeight:400}}>
					<h1><em>{data.name}</em></h1><hr width="20%" color="white"/>
					<p className="pb-0 mb-0">{data.designation}</p>
				</div>
				<div className="temp-2-section1">
					<ul className="temp-2 mt-5 ml-0 pl-0" style={{listStyle:"none"}}>
					
					<div className="head" style={{textAlign:"center",fontSize:"20px"}}>About me</div>
					<div align="center"><hr style={{margin:0,width:"50px"}}/></div>
						<div className="my-3 px-1">
							<ul>
								<p style={{textAlign:"center"}}>{data.intro}</p>
							</ul>
						</div>
					<li><div className="head"><i className="fas fa-graduation-cap mx-2"></i>  Education</div>
						<div className="my-2">
							<ul>
							{data.education.map((edu,index)=>(
								<li className="pl-2">
									<p><strong className="education">{edu.course}</strong><br/>
									   {edu.field}<br/>
									   {edu.college}<br/>
									   Aggregate : {edu.score}%<br/>
									   <em>({(new Date(edu.start)).toDateString().substring(4,8)+(new Date(edu.start)).toDateString().substring(11)} - {(new Date(edu.end)).toDateString().substring(4,8)+(new Date(edu.end)).toDateString().substring(11)})</em>
									</p>
								</li>
							))}
							</ul>
						</div>
					</li>
					<li><div className="head"><i className="fas fa-book-reader mx-2"></i>  Interests</div>
						<div  className="my-3">
							<ul>
							{data.interests.map((interest,index)=>(
								<li className="pl-2">{interest}</li>
							))}
							</ul>
						</div>
					</li>
					<li><div className="head"><i className="fas fa-laptop-code mx-2"></i>  Projects</div>
						<div className="my-3">
							<ul>
							{data.projects.map((project,index)=>(
								<li className="pl-2"><strong>{project.title}</strong><br/>
									<small>{project.desc}</small><br/>
									<small><a href={`${project.reference}`}>{project.reference}</a></small>
								</li>
							))}
							</ul>
						</div>
					</li>
					</ul>
				</div>
				<div className="temp-2-section2 pb-5">
					<div className="mt-5 ml-4">
					<p><strong><i className="fas fa-address-card mr-2"></i></strong><span style={{marginLeft:"4%"}}>{data.address}</span></p>
					<p><strong><i className="fas fa-phone mr-2"></i></strong><span style={{marginLeft:"5%"}}>{data.contact}</span></p>
					<p><strong><i className="fas fa-envelope-open mr-2"></i></strong><span style={{marginLeft:"5%"}}><a href={`mailto:${data.email}`} style={{color:"black"}}>{data.email}</a></span></p>
					</div>
					<ul className="mt-5 ml-0 pl-0" style={{listStyle:"none"}}>
					<li><div className="head"><i className="fas fa-code mx-2"></i>  Skills</div>
						<div className="my-2">
							<ul  style={{listStyle:"none"}}>
							{data.skills.map((skill,index)=>(
								<li className="pl-2">{skill.skill}
									{skill.prof && (<div className="progress" style={{width:"80%"}}>
  									<div className="progress-bar progress-bar-striped" role="progressbar" aria-valuenow={skill.prof} aria-valuemin="0" aria-valuemax="100" style={{width:`${skill.prof}%`}}></div>
									</div>
									)}
								</li>
							))}
							</ul>
						</div>
					</li>
					<li><div className="head"><i className="fa fa-trophy mx-2" aria-hidden="true"></i>  Work Experience</div>
						<div className="my-3">
							<ul>
							{data.workExp.map((work,index)=>(
								<li className="pl-2"><strong>{work.company}</strong><br/>
									<p>{work.desc}<br/>
									- <em>{work.title}</em>
									</p>
								</li>
							))}
							</ul>
						</div>
					</li>
					<li><div className="head"><i className="fas fa-clipboard-list mx-2"></i>  Additional Information</div>
						<div className="my-3">
							<ul>
							{data.addInfo.map((info,index)=>(
								<li className="pl-2"><strong>{info.title}</strong>  : <a href={`${info.reference}`}><small>{info.reference}</small></a></li>
							))}
							</ul>
						</div>
					</li>
					<li><div className="head"><i className="fa fa-language mx-2" aria-hidden="true"></i>   Languages Known</div>
						<div  className="my-3">
							<ul className="lang" style={{listStyle:"none"}}>
							{data.langKnown.map((lang,index)=>(
								<><li className="pl-2">{lang}</li><hr className="mx-2"/></>
							))}
							</ul>
						</div>
					</li>
					</ul>
				</div>
			</div>
		</motion.div>
		</>
	)
}